<app-login-choice-button
  logoImage="/assets/img/Google_G_Logo.png"
  [text]="'login.buttons.google' | translate"
  (selected)="selected.emit('Google')"
></app-login-choice-button>

<app-login-choice-button
  logoImage="/assets/img/microsoft.svg"
  [text]="'login.buttons.microsoft' | translate"
  (selected)="selected.emit('Microsoft')"
></app-login-choice-button>

<div class="divider" role="separator" aria-hidden="true">
  <span class="divider__label">{{ 'login.or' | translate }}</span>
</div>

<app-login-choice-button
  id="continue-with-email"
  variant="primary"
  logoIcon="mail"
  [text]="'login.buttons.cognito' | translate"
  (selected)="selected.emit('Cognito')"
></app-login-choice-button>
